module.exports = __webpack_public_path__ + "img/video clapperboard.11404716.svg";